import React from 'react';
import { DocumentCard, DocumentCardTitle
//  , DocumentCardPreview  
} from 'office-ui-fabric-react/lib/DocumentCard'
import CompetenciesArray from './CompetenciesArray' // GCI
import Competencies from './Competencies'

/*
const cpToPreview = (cps) => cps.map( cp => ({ name: cp.name, width: 318, height: 196 }) )
{item.competencies
        ? <DocumentCardPreview previewImages={cpToPreview(item.data.competencies)} />
        : <div>No competencies</div>
        }
showId is assigned in Activities container
*/
export default ({items, handleActivity, selectedActivity, showId}) => (
    <div>
      { selectedActivity 
        ? selectedActivity.company.id === 'GCI' 
          ? <CompetenciesArray activity={selectedActivity} />
          : <Competencies activity={selectedActivity} showId={showId} />
        : items 
          ? items.map( (item,i) => 
                <DocumentCard key={i} onClick={e => handleActivity(item,
                { text: item.data.name, 'key': 'item.id' + i })}>
                    <DocumentCardTitle title={showId ? item.data.name + ' ' + item.id : item.data.name} />
                  </DocumentCard> )
          : <span>Loading Activities</span>
      }
    </div>
)



// WEBPACK FOOTER //
// ./src/activities/components/Activities.js